import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BaseAccordionComponent } from '../base-accordion.component';
import { AccordionService } from 'src/app/services/accordion.service';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-visit-detail-overview',
  templateUrl: './visit-detail-overview.component.html',
  styleUrls: ['./visit-detail-overview.component.scss'],
})
export class VisitDetailOverviewComponent extends BaseAccordionComponent {
  @Input() visit;
  @Input() scoreStatuses: any;
  @Input() date: string;
  @Input() dayNumber: string;
  @Input() hasUnreadMessages$: Observable<boolean> = of(false);
  googleMapsUrl = 'https://www.google.com/maps/dir/';

  constructor(
    protected accordionService: AccordionService,
    private router: Router
  ) {
    super(accordionService);
  }

  call(phoneNumber: string) {
    if (phoneNumber) {
      window.open(`tel:${phoneNumber}`);
    }
  }
  generateRouteLink() {
    let url = this.googleMapsUrl;

    if (this.visit.locationLat && this.visit.locationLng) {
      url += `/${this.visit.locationLat},${this.visit.locationLng}`;
      window.open(encodeURI(url), '_system', 'location=no');
    }
  }

  generateLinkToLocation() {
    const url = `https://maps.google.com/?q=${this.visit?.locationAddress},${this.visit?.locationCity},${this.visit?.locationPostCode}`;
    window.open(encodeURI(url), '_system', 'location=no');
  }

  openChat() {
    if (this.visit?.chatId) {
      const backUrl = `/visitday/details/${this.date}/${this.visit.visitId}/${this.dayNumber}`;
      this.router.navigate(['/chat', this.visit.chatId], {
        state: {
          visitId: this.visit.visitId,
          backUrl,
        },
      });
    }
  }
}
